import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
export function OperationSectionHeading({ children }) {
    return (_jsx("div", { className: "px-2", children: _jsx("div", { className: clsx('mt-3 border-b border-zinc-950/10 py-2 dark:border-white/10'), children: _jsx("h2", { className: "text-sm font-medium leading-6 text-zinc-950 dark:text-white", children: children }) }) }));
}
